import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  client: {
    // Automatically generated by Convex
    NEXT_PUBLIC_CONVEX_URL: z.string().url().min(1),

    // Landing page env variables (there are some problems with hardcoding them in preview deployments
    // so just copy and paste them into your .env.local file)
    NEXT_PUBLIC_LINKEDIN_URL: z.string().url().min(1),
    NEXT_PUBLIC_CALL_TO_ACTION_URL: z.string().url().min(1),
    NEXT_PUBLIC_X_URL: z.string().url().min(1),

    // Clerk
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string().min(1),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_CONVEX_URL: process.env.NEXT_PUBLIC_CONVEX_URL,
    NEXT_PUBLIC_LINKEDIN_URL: process.env.NEXT_PUBLIC_LINKEDIN_URL,
    NEXT_PUBLIC_CALL_TO_ACTION_URL: process.env.NEXT_PUBLIC_CALL_TO_ACTION_URL,
    NEXT_PUBLIC_X_URL: process.env.NEXT_PUBLIC_X_URL,
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
  },
});
